import React, { useContext } from "react";
import { Link } from "react-router-dom";

import './Navbar.css';
import navLogo from '../../resources/images/Logo_consultoria.svg';
import { AuthContext } from "../../core/context/authContext";

const Navbar = () => {

    const authenticatedStatus = 'authenticated';
    const { status, handleLogOut } = useContext(AuthContext);

    const adminNav = (
        <>
            <li className="nav-item">
                <Link className="nav-link" to={'historial-encuestas'}>
                    Historial
                </Link>
            </li>
            {/* Se oculta en producción */}
            {(process.env.NODE_ENV !== 'production') ?
                <li className="nav-item">
                    <Link className="nav-link" to={'listado-preguntas'}>
                        Preguntas
                    </Link>
                </li> : ''
            }
        </>
    )

    return (
        <nav className="navbar navbar-expand-lg navbar-custom bg-body-tertiary" data-bs-theme="light">
            <div className="container-fluid">
                <Link className="navbar-brand" to={'encuesta'}>
                    {/* Encuesta */}
                    <img src={navLogo} alt="Navbar Logo" />
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        {(status === authenticatedStatus ? adminNav : '')}
                    </ul>
                    <div className="d-flex justify-content-end">
                        {(status === authenticatedStatus ?
                            <button onClick={() => handleLogOut()} className="btn btn-custom">Salir</button>
                            :
                            <Link to={'login'}>
                                <button className="btn btn-custom">Login</button>
                            </Link>)}
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Navbar;